// Bantuan.js
import React, { useState, useEffect, useMemo, useCallback } from "react"; // ADD useEffect,useMemo,useCallback
import Sidebar from "../../Component/Sidebar/Sidebar";
import Header from "../../Component/Header/Header";
import "./Bantuan.css";

export default function BantuanPage() {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const [openIndex, setOpenIndex] = useState(null);

  // ===== ADD: deteksi mobile (≤1024px)
  const getIsMobile = () =>
    typeof window !== "undefined" &&
    window.matchMedia("(max-width: 1024px)").matches;
  const [isMobile, setIsMobile] = useState(getIsMobile());

  useEffect(() => {
    const mql = window.matchMedia("(max-width: 1024px)");
    const onChange = (e) => setIsMobile(e.matches);
    mql.addEventListener("change", onChange);
    return () => mql.removeEventListener("change", onChange);
  }, []);

  // default state: mobile tutup, desktop buka
  useEffect(() => {
    setIsSidebarOpen(!isMobile);
  }, [isMobile]);

  // ===== ADD: terapkan kelas DOM untuk off-canvas
  const applyDomClasses = useCallback(
    (open) => {
      const body = document.body;
      const sidebarEl = document.querySelector(".bantuan-page .sidebar");
      const overlayEl = document.querySelector(".bantuan-page .sidebar-overlay");
      if (isMobile) {
        if (open) {
          sidebarEl?.classList.add("is-mobile-open");
          overlayEl?.classList.add("is-visible");
          body.classList.add("lock-scroll");
        } else {
          sidebarEl?.classList.remove("is-mobile-open");
          overlayEl?.classList.remove("is-visible");
          body.classList.remove("lock-scroll");
        }
      } else {
        sidebarEl?.classList.remove("is-mobile-open");
        overlayEl?.classList.remove("is-visible");
        body.classList.remove("lock-scroll");
      }
    },
    [isMobile]
  );

  useEffect(() => {
    applyDomClasses(isSidebarOpen);
  }, [isSidebarOpen, applyDomClasses]);

  const toggleSidebar = () => setIsSidebarOpen((v) => !v);
  const handleOverlayClick = () => setIsSidebarOpen(false);

  // ===== ADD: kelas main-content
  const mainContentClass = useMemo(() => {
    if (isMobile) return "main-content sidebar-closed";
    return `main-content ${isSidebarOpen ? "sidebar-open" : "sidebar-closed"}`;
  }, [isMobile, isSidebarOpen]);

  const faqs = [
    { question: "Bagaimana cara menambah pengeluaran atau pemasukan baru?", answer: "Cukup tekan tombol 'Tambah Transaksi', lalu isi detail pengeluaran atau pemasukan kamu." },
    { question: "Bagaimana cara menambahkan kategori baru untuk pengeluaran atau pemasukan?", answer: "Masuk ke menu 'Kategori', lalu tekan 'Tambah Kategori' dan isi nama serta ikon yang kamu inginkan." },
    { question: "Apakah saya bisa menggunakan LacaKas di lebih dari satu perangkat?", answer: "Bisa. Pastikan kamu login dengan akun yang sama agar data otomatis tersinkronisasi." },
    { question: "Apakah LacaKas bisa digunakan tanpa koneksi internet?", answer: "Tidak Bisa. Kamu tidak dapat mencatat transaksi secara offline, dan data tidak akan tersinkron otomatis saat online kembali." },
    { question: "Apakah penggunaan LacaKas gratis?", answer: "Ya, LacaKas bisa digunakan secara gratis. Namun, ada fitur premium untuk pengalaman yang lebih lengkap." },
  ];

  const handleFaqToggle = (index) => setOpenIndex(openIndex === index ? null : index);

  return (
    <div className="bantuan-page">
      <Sidebar isOpen={isSidebarOpen} />

      {/* ADD: overlay untuk mobile */}
      <div className="sidebar-overlay" onClick={handleOverlayClick} aria-hidden={!isSidebarOpen} />

      <div className={mainContentClass}>
        <Header toggleSidebar={toggleSidebar} />

        <div className="bantuan-container">
          {/* Breadcrumb + Title */}
          <div className="bantuan-header">
            <div className="breadcrumb-bantuan">
              <span className="breadcrumb-item">Halaman</span>
              <span className="breadcrumb-separator">/</span>
              <span className="breadcrumb-item active">Bantuan</span>
            </div>
            <h1 className="bantuan-title">Bantuan</h1>
          </div>

          {/* FAQ */}
          <div className="faq-section">
            <h1>Pertanyaan Sering Diajukan (FAQ)</h1>
            {faqs.map((faq, index) => (
              <div
                key={index}
                className={`faq-item ${openIndex === index ? "active" : ""}`}
                onClick={() => handleFaqToggle(index)}
              >
                <div className="faq-question">
                  <p>{faq.question}</p>
                  <span>{openIndex === index ? "▲" : "⯈"}</span>
                </div>
                {openIndex === index && (
                  <div className="faq-answer">
                    <p>{faq.answer}</p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>

        <footer className="dashboard-footer">
          <p>@copyright 2025 - LacaKas</p>
        </footer>
      </div>
    </div>
  );
}
